import { IWintabConfigBase, IWintabFrameConfig } from '@Core/Wintab/Wintab.types';

export const framesConfig: IWintabFrameConfig[] = [];

////TODO: Migrate to PIXI
export const fieldsTextStyle: any = {};

export const WINTAB_CONFIGURATION_DEFAULT: IWintabConfigBase = {
    atlasKey: '',
    backgroundName: '',
    fieldsTextStyle: fieldsTextStyle,
    frames: framesConfig,
    logoGraphicsName: '',
    logoPosition: undefined
};
